import styled from "@emotion/styled";
import { Button, PageTable, Title } from "@src/components";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getExpertApprovalListColumns } from "./ExpertApprovalListColumns";
import useExpertApprovalList, {
    getExpertApprovalListParams,
    useUpdateExpertApproval,
} from "@src/hooks/queries/useExpertApprovalList";
import ExpertApprovalFilter from "./ExpertApprovalFilter";
import { useApproveExperts } from "@src/hooks/queries/useExpertDetail";

const initParams: getExpertApprovalListParams = {
    page: 1,
    limit: 20,
    cursor: "",
    searchEndDate: "",
    searchStartDate: "",
    searchKeyword: "",
    type: [],
    searchType: "",
};

const ExpertApprovalList = () => {
    const navigate = useNavigate();
    const [selectedExperts, setSelectedExperts] = useState<number[]>([]);

    const handleCheckAllItem = () => {
        setSelectedExperts(
            selectedExperts.length === data?.expertApprovalList.filter((item) => item.status !== "승인완료").length
                ? []
                : data?.expertApprovalList.filter((item) => item.status !== "승인완료").map((item) => item.expertNo) ??
                      [],
        );
    };
    const handleCheckItem = (userExpertNo: number) => {
        if (data?.expertApprovalList.find((item) => item.expertNo === userExpertNo)?.status === "승인완료") {
            alert("이미 승인완료된 회원입니다.");
            return;
        }
        if (selectedExperts.includes(userExpertNo)) {
            setSelectedExperts(selectedExperts.filter((item) => item !== userExpertNo));
        } else {
            setSelectedExperts([...selectedExperts, userExpertNo]);
        }
    };

    const columns = getExpertApprovalListColumns(navigate, selectedExperts, handleCheckItem);

    const [params, setParams] = useState<getExpertApprovalListParams>(initParams);

    const { data, refetch: refetchApprovalList } = useExpertApprovalList(params);
    const { mutate: approveExperts } = useApproveExperts();

    const handleExpertsApproval = () => {
        if (selectedExperts.length === 0) {
            alert("승인할 회원을 선택해주세요.");
            return;
        }
        approveExperts(selectedExperts, {
            onSuccess: () => {
                refetchApprovalList();
                setSelectedExperts([]);
            },
        });
    };

    useEffect(() => {
        console.log("params", params);
    }, [params]);

    useEffect(() => {
        refetchApprovalList();
    }, []);

    return (
        <>
            <StyledExpertUserList>
                <Title title="매수신청대리인 승인 관리" />
                <ExpertApprovalFilter filters={params} setFilters={setParams} />

                <div className="filterBtnBox">
                    <Button
                        color="gray"
                        handleClick={() => {
                            setParams(initParams);
                            refetchApprovalList();
                        }}
                        label="전체 해제"
                        size="medium"
                    />
                    <Button
                        color="purple"
                        handleClick={() => {
                            console.log("params", params);
                            if (
                                (Object.hasOwn(params, "searchKeyword") && !Object.hasOwn(params, "searchType")) ||
                                (Object.hasOwn(params, "searchType") && !Object.hasOwn(params, "searchKeyword"))
                            ) {
                                alert("검색 조건과 키워드를 확인해주세요");
                                return;
                            }
                            refetchApprovalList();
                        }}
                        label="검색"
                        size="medium"
                        isDisabled={false}
                    />
                </div>
                <div className="tableDiv">
                    <div className="selectBtnBox">
                        <Button
                            color="gray"
                            handleClick={handleCheckAllItem}
                            label={`전체 회원 ${
                                selectedExperts.length === data?.expertApprovalList.filter((item) => item.status !== "승인완료").length ? "해제" : "선택"
                            }`}
                            size="small"
                            isDisabled={false}
                        />
                        <Button
                            color="white"
                            handleClick={() => {
                                handleExpertsApproval();
                            }}
                            label="선택 회원 승인"
                            size="small"
                            isDisabled={false}
                        />
                    </div>
                    <PageTable
                        columns={columns}
                        data={data?.expertApprovalList ?? []}
                        initialState={{
                            pageIndex: 0,
                            pageSize: params.limit,
                        }}
                        FixedHeight={500}
                        showTotalCount={true}
                        totalCount={data?.expertApprovalList.length ?? 0}
                        handlePageChange={(index: number) => {
                            const page = index + 1;
                            setParams({
                                ...params,
                                page,
                            });
                        }}
                    />
                </div>
            </StyledExpertUserList>
        </>
    );
};

export default ExpertApprovalList;

const StyledExpertUserList = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;

    .filterBtnBox {
        display: flex;
        gap: 10px;
        flex-direction: row;
        justify-content: flex-end;
        padding-top: 10px;
        margin-bottom: 40px;
    }
    .tableDiv {
        margin-top: 60px;
        position: relative;
    }

    .selectBtnBox {
        position: absolute;
        top: 0;
        left: 80px;
        display: flex;
        gap: 10px;
        flex-direction: row;
        padding-top: 10px;
    }
`;

const FlexBox = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

const FlexColumnBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
